import showMessage from "./common/showMessage";
const handleRequestSuccess = (reservationForm) => () => {
    var _a, _b;
    const encourageMessage = document.querySelector("p.encourage-message");
    if (encourageMessage) {
        encourageMessage.remove();
    }
    (_a = reservationForm.querySelector("input[type='submit']")) === null || _a === void 0 ? void 0 : _a.classList.remove("loading");
    (_b = reservationForm.querySelector("input[type='submit']")) === null || _b === void 0 ? void 0 : _b.removeAttribute("disabled");
    const errorMessage = document.querySelector("div.error-message");
    if (errorMessage) {
        errorMessage.remove();
    }
    showMessage.thankyou(reservationForm, "<p>体験申し込みをしていただき、ありがとうございます。<br>ご入力していただいたメールアドレスに、<br>確認メールを送信しましたので、ご確認ください。迷惑メールに分類されている場合もありますので、そちらもご確認ください。15分待ってメールが来ない場合は別のメールアドレスで再登録してください。</p><p>または、<a href='mailto:info@tryupdance.com' target='_blank' rel='noopener noreferrer'>info@tryupdance.com</a>までお問い合わせください</p>");
};
export default handleRequestSuccess;
